import {FetchBaseQueryError} from '@reduxjs/toolkit/query';

import {isNotNilOrEmpty} from 'ramda-adjunct';

import {ApiError} from '../types/ApiError';

export const isFetchBaseQueryError = (error: ApiError): error is FetchBaseQueryError =>
  isNotNilOrEmpty(error) ? 'data' in error : false;
